import React, { Suspense, useCallback } from 'react';
import { useEffect } from 'react';

import { isNudeDomain } from '../../utils/helpers';
import FullLoader from '../../components/Loaders/FullLoader';
import { emitGAEvent } from '../../utils/GAUtils';


const GuestHomePage = React.lazy(() =>
  import('../../pages/Home/GuestHomePage')
);
const GuestHomePageV2 = React.lazy(() =>
  import('../../pages/Home/v2/GuestHomePageV2')
);
const MembersHomePage = React.lazy(() => import('../../pages/Home/Home'));

export function getHomeVariant() {
  const key = 'homepage_variant';
  const existing = localStorage.getItem(key);
  const splitPercentage = 0.5;


  if (existing) {
    return existing;
  }
  const variant = Math.random() < splitPercentage ? 'A' : 'B';

  localStorage.setItem(key, variant);

  return variant;
}

function HomePage(props) {
  const { user, activeCampaign, history, location } = props;
  const guestHomePageVariant = getHomeVariant();
  const homePageVariantOverride = localStorage.getItem('homepage_variant_override');

  const userWithNoActiveMembership = !user?.user?.activeSubscription;

  useEffect(() => {
    emitGAEvent('page_land', 'page_land', guestHomePageVariant, 'page_land');
  }, []);


  const homePageToRender = useCallback(() => {
    if (
      userWithNoActiveMembership &&
      !isNudeDomain &&
      ((guestHomePageVariant === 'A') || homePageVariantOverride === 'A')
    ) {
      return (
        <GuestHomePageV2
          activeCampaign={activeCampaign}
          history={history}
          location={location}
          user={user}
        />
      );
    }
    if (userWithNoActiveMembership && !isNudeDomain) {
      return (
        <GuestHomePage
          activeCampaign={activeCampaign}
          history={history}
          location={location}
          user={user}
        />
      );
    }

    return (
      <MembersHomePage
        activeCampaign={activeCampaign}
        history={history}
        location={location}
        user={user}
      />
    );
  }, [
    activeCampaign,
    history,
    userWithNoActiveMembership,
    location,
    user,
    guestHomePageVariant,
  ]);

  return <Suspense fallback={<FullLoader />}>{homePageToRender()}</Suspense>;
}

export default HomePage;
